<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <v-col cols="12" align="center" justify="center">
            <h1 v-text="note != null ? note.name : ''"></h1>
          </v-col>
          <v-alert
            icon="mdi-folder"
            type="success"
            color="primary"
            width="90%"
            outlined
          >
            {{ noteCountTitle(note) }}
          </v-alert>
          <v-alert
            icon="🎉"
            type="success"
            color="secondary"
            width="90%"
            outlined
          >
            {{ noteDoneTitle(note) }}
          </v-alert>
          <p color="grey lighten-1">{{ testDesc(note) }}</p>
          <template v-if="testAvaiable(note)">
            <v-btn
              class="mt-4 start-btn"
              fixed
              bottom
              color="primary"
              width="90%"
              height="60px"
              dark
              @click="startTest"
            >
              テストを開始する
            </v-btn>
          </template>
          <template v-if="!testAvaiable(note)">
            <v-btn
              class="mt-4 disabled-btn"
              fixed
              bottom
              width="90%"
              height="60px"
              dark
              @click="cancelTest"
            >
              完了していない単語がある場合に使えます
            </v-btn>
          </template>
        </v-row></v-col
      ></v-row
    ></v-container
  >
</template>

<script>
import { db, fb } from "../plugins/firebase.js";

export default {
  name: "WordNoteTest",
  components: {},
  data: () => ({
    note: null,
  }),
  computed: {
    uid() {
      return this.$store.getters.uid;
    },
  },
  async mounted() {
    const noteId = this.$store.getters.currentNoteId;
    this.noteId = noteId;
    this.fetchNote(noteId);
  },
  methods: {
    async fetchNote(noteId) {
      const that = this;
      const noteSubscription = db
        .collection(`users/${this.uid}/word-notes`)
        .doc(noteId)
        .onSnapshot(function (doc) {
          that.note = doc.data();
        });
    },
    noteCountTitle(note) {
      if (note == null) {
        return "";
      } else {
        return `収録数: ${note.wordCount}語`;
      }
    },
    noteDoneTitle(note) {
      if (note == null) {
        return "";
      } else {
        return `完了数: ${note.doneCount}/${note.wordCount}語`;
      }
    },
    testDesc(note) {
      if (note == null) {
        return "";
      } else {
        return `※未完了の${note.wordCount - note.doneCount}語をテストします`;
      }
    },
    testAvaiable(note) {
      if (note != null) {
        return note.wordCount - note.doneCount > 0;
      } else {
        return false;
      }
    },
    startTest() {
      this.$router.push({
        name: "word-note-test-mode",
        params: { note: this.note },
      });
    },
    cancelTest() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 600px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
}
.start-btn {
  max-width: 600px;
}
.disabled-btn {
  max-width: 600px;
  color: white !important;
  background-color: gray !important;
}
</style>
